import { WrapperWidget } from '@agentselly/ui';
import { T } from '@tolgee/react';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly link: string;
}

export function MyEnergyGuideWidget(props: Props) {
  return (
    <WrapperWidget>
      <div className="h-full flex flex-col gap-y-6">
        <h2 className="text-lg font-bold">
          <T>evaluation_myenergyguide_widget_title</T>
        </h2>
        <p>
          <T>evaluation_energy_teaser</T>
        </p>

        <a
          href={props.link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <Button showArrow>
            <T>evaluation_myenergyguide_widget_button_text</T>
          </Button>
        </a>
      </div>
    </WrapperWidget>
  );
}
